import AdminLogsBlock from "../../components/personal/AdminSettingsPage/AdminLogs/AdminLogsBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AdminLogs = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Логи"}>
            <AdminLogsBlock/>
        </TypicalPageStructure>
        </>
    )
}
export default AdminLogs;